// extracted by mini-css-extract-plugin
export default {"bar":"HiwProgressBar_bar__uge+n"};